<template lang="pug">
  div.certificate-container
    v-snackbar(v-model="showError" :timeout="5000" color="reject" bottom right)
      | {{errorMessage}}


    v-progress-circular(
      v-if="isFetchingCertificate"
      indeterminate
      color="secondaryDark"
    )

    button.blue--text.certificate-link(
      v-else-if="name"
      @click="handleCertificateClick"
    ) {{name}}
</template>

<script lang="ts">
import Vue from 'vue';
import {
  fetchSizeChartCertificate,
  fetchSizeChartCertificateMetadata,
} from 'Api/endpoints/masterdata/masterdata-certificate.endpoint';
import { downloadFile } from 'Common/utils/download-file';

const CERTIFICATE_FETCH_FAILED = 'Failed to fetch the certificate file.';
const METADATA_FETCH_FAILED =
  'Failed to fetch matadata for the certificate file.';

export default Vue.extend({
  props: {
    certificateId: {
      type: String,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      errorMessage: '',
      showError: false,
      isFetchingCertificate: false,
      name: '',
      mediaType: '',
      // @ts-ignore
      ...this.mapState({
        merchantId: 'flow.general.merchant.data.$id',
      }),
    };
  },

  async mounted() {
    try {
      if (this.merchantId && this.certificateId) {
        const metadata = await fetchSizeChartCertificateMetadata(
          this.merchantId,
          this.certificateId
        );
        this.mediaType = metadata.mediaType;
        this.name = metadata.filename;
      }
    } catch (e) {
      this.showMetaDataFetchFailedMessage(e);
    }
  },

  methods: {
    async handleCertificateClick(): Promise<void> {
      try {
        this.showError = false;
        this.isFetchingCertificate = true;
        const fileContent = await fetchSizeChartCertificate(
          this.merchantId,
          this.certificateId,
          this.mediaType
        );

        downloadFile({
          fileContent,
          fileName: this.name,
          mediaType: this.mediaType,
        });

        this.isFetchingCertificate = false;
      } catch (e) {
        this.showCertificateFetchFailedMessage(e);
      }
    },
    showMetaDataFetchFailedMessage(e): void {
      this.isFetchingCertificate = false;
      this.errorMessage = e.error ? e.error.message : METADATA_FETCH_FAILED;
      this.showError = true;
    },
    showCertificateFetchFailedMessage(e): void {
      this.isFetchingCertificate = false;
      this.errorMessage = e.error ? e.error.message : CERTIFICATE_FETCH_FAILED;
      this.showError = true;
    },
  },
});
</script>

<style lang="scss" scoped>
.certificate-container {
  flex: 1;
}
.certificate-link {
  overflow-wrap: anywhere;
  text-align: left;
  transition: 0.3s;
  cursor: pointer;
}
.certificate-link:hover {
  opacity: 0.7;
}
</style>
